import type { ModelCompatibleTool } from "../../Board/types.ts";
import {
  CHARACTER_MODEL_TYPE,
  OBJECT_MODEL_TYPE,
  STYLE_MODEL_TYPE,
} from "../../constants.ts";
import { toolToSelectedModelsStorage } from "../stores/selectedModels/toolToSelectedModelsStorage.ts";

export const useSelectedModelsSettingsAndActions = (
  tool: ModelCompatibleTool,
  boardUuid: string,
  initialModelUuid?: string,
) => {
  const selectedModelsStorage = toolToSelectedModelsStorage[tool];

  const selectedModelsSettings = selectedModelsStorage.useModelsSettings(
    boardUuid,
    tool,
  );
  const modelActions = selectedModelsStorage.modelActions(boardUuid);
  const allModels = selectedModelsStorage.useAllModels(
    boardUuid,
    tool,
    initialModelUuid,
  );
  const areSelectedModelsValid =
    selectedModelsStorage.useAreSelectedModelsValid(boardUuid, tool);

  const numberOfOtherCompatibleModels = {
    [CHARACTER_MODEL_TYPE]:
      selectedModelsStorage.useNumberOfOtherCompatibleModels(
        boardUuid,
        tool,
        CHARACTER_MODEL_TYPE,
      ),
    [OBJECT_MODEL_TYPE]: selectedModelsStorage.useNumberOfOtherCompatibleModels(
      boardUuid,
      tool,
      OBJECT_MODEL_TYPE,
    ),
    [STYLE_MODEL_TYPE]: selectedModelsStorage.useNumberOfOtherCompatibleModels(
      boardUuid,
      tool,
      STYLE_MODEL_TYPE,
    ),
  };

  return {
    selectedModelsSettings,
    modelActions,
    allModels,
    numberOfOtherCompatibleModels,
    areSelectedModelsValid,
  };
};
